"use client";
import React from "react";
import { debounce, assign } from "lodash";
const useCopyText = () => {
  const ref: any = React.useRef({});
  const [copied, $copied] = React.useState(false);
  assign(ref.current, { copied, $copied });
  const handler = {
    copy: (val: string) => {
      if (!ref.current.copied) {
        navigator.clipboard.writeText(val);
        ref.current.$copied(true);
        debounce(() => {
          ref.current.$copied(false);
        }, 2000)();
      }
    },
  };
  assign(ref.current, { handler });
  return ref.current;
};
export default useCopyText;
